export default class AuthConfig {
  clientId: string = '';
  resourceId: string = '';
  redirectUri: string = '';
  tenant: string = '';
}
